export default "__VITE_ASSET__Bu6BWa4h__"